import * as yup from "yup";

const familyMemberSchema = yup.object({
    relation: yup.string().trim().required("Relation is required."),

    firstName: yup.string().trim().required("First name is required."),

    lastName: yup.string().trim().required("Last name is required."),

    dateOfBirth: yup
        .string()
        .nullable()
        .test(
            "not-in-future",
            "Date of birth cannot be in the future.",
            (value) => {
                if (!value) {
                    return true;
                }

                return new Date(value) <= new Date();
            }
        ),
    phoneNumber: yup
        .string()
        .trim()
        .matches(/^[0-9+\-() ]*$/, "Phone number contains invalid characters."),

    phoneNumberExt: yup
        .string()
        .trim()
        .matches(/^[0-9]*$/, "Extension must contain numbers only.")
});

export default familyMemberSchema;
